import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ConsiderationSupportDetailsModalModule } from '@app/my-booking/sub-components/my-booking-service/sub-components/consideration-support-details-modal/consideration-support-details-modal.module';
import { TextTooltipModule } from '@lib/components';
import { TooltipDirectiveModule } from '@lib/directives';
import { StaticMsgModule } from '@lib/pipes';
import { ConsiderationSupportComponent } from './consideration-support.component';
import { TextWithTooltipModule } from '@common/components/text-with-tooltip/text-with-tooltip.module';

@NgModule({
  declarations: [ConsiderationSupportComponent],
  imports: [
    CommonModule,
    StaticMsgModule,
    ConsiderationSupportDetailsModalModule,
    TooltipDirectiveModule,
    TextTooltipModule,
    TooltipDirectiveModule,
    TextWithTooltipModule,
  ],
  exports: [ConsiderationSupportComponent],
})
export class ConsiderationSupportModule {}
